module.exports = __webpack_public_path__ + "static/media/tone2_ok.d23c3a51.svg";